import { useEffect, useState } from 'react';
import { Truck, RotateCcw } from 'lucide-react';
import api from '@/lib/api';
import { PageSEO } from '@/components/SEO';

export default function ShippingReturns() {
  const [shippingReturns, setShippingReturns] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get('/site-builder/store-settings');
        setShippingReturns(res.data?.shipping_returns || {});
      } catch (error) {
        console.error('Failed to load shipping & returns info');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const { shipping_info, returns_info } = shippingReturns;

  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="shipping-returns-page">
      <PageSEO.shipping />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-medium mb-4">Shipping & Returns</h1>
        <p className="text-lg text-stone-600 mb-12">
          Everything you need to know about shipping and our return policy.
        </p>

        {loading ? (
          <div className="space-y-8">
            <div className="h-48 bg-stone-100 rounded animate-pulse" />
            <div className="h-48 bg-stone-100 rounded animate-pulse" />
          </div>
        ) : (
          <div className="space-y-12">
            {/* Shipping Section */}
            <section>
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-stone-100 rounded-full">
                  <Truck className="h-6 w-6 text-stone-700" />
                </div>
                <h2 className="text-2xl font-medium">Shipping Information</h2>
              </div>
              
              {shipping_info ? (
                <div className="prose prose-stone max-w-none">
                  <div className="whitespace-pre-wrap text-stone-600 leading-relaxed bg-stone-50 rounded-lg p-6">
                    {shipping_info}
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-stone-500 bg-stone-50 rounded-lg">
                  <p>Shipping information coming soon.</p>
                </div>
              )}
            </section>

            {/* Returns Section */}
            <section>
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-stone-100 rounded-full">
                  <RotateCcw className="h-6 w-6 text-stone-700" />
                </div>
                <h2 className="text-2xl font-medium">Returns Policy</h2>
              </div>
              
              {returns_info ? (
                <div className="prose prose-stone max-w-none">
                  <div className="whitespace-pre-wrap text-stone-600 leading-relaxed bg-stone-50 rounded-lg p-6">
                    {returns_info}
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-stone-500 bg-stone-50 rounded-lg">
                  <p>Returns policy coming soon.</p>
                </div>
              )}
            </section>

            {!shipping_info && !returns_info && (
              <div className="text-center py-4 text-stone-500">
                <p className="text-sm">Please contact us for shipping and returns inquiries.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
